<template>
  <div v-loading="loading" class="pdf p-20">
    <div v-if="showImg" class="img-box">
      <img @error="imgError" :src="imgUrl" alt="" class="img" />
    </div>
    <template v-else>
      <pdf v-for="i in pageCount" :key="i" :src="src" :page="i" class="pdf-img" />
    </template>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import { getToken } from "@/utils/auth";
import { fetchFileList } from "@/api/file";
export default {
  components: { pdf },
  props: {
    fileId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      src: "", // pdf文件地址
      header: {
        "X-Token": getToken()
      },
      imgType: ["png", "jpg", "jpeg", "bmp", "gif", "webp"],
      showImg: false,
      imgUrl: "",
      fileInfo: {},
      loading: true
    };
  },
  mounted() {
    console.log(this.fileId);
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      console.log("fileId:", this.fileId);
      const ids = this.fileId;
      const res = await fetchFileList(ids);

      if (res.IsSuccess) {
        if (res.Result && res.Result.length > 0) {
          this.fileInfo = res.Result[0];

          this.loadFile();
        }
      } else {
        if (res.Message === "认证失败") {
          this.$message("请登录后再查看！");
        } else {
          this.$message.error(res.Message);
        }
      }
    },
    loadFile() {
      // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
      let link = this.fileInfo.FilePath;
      const type = link.substring(link.lastIndexOf(".") + 1);
      // console.log(!link.startsWith('/files') && !link.startsWith('http'))
      if (!link.startsWith("/files") && !link.startsWith("http")) {
        link = "/files/" + link;
      }
      if (this.isImg(type)) {
        this.showImg = true;
        this.imgUrl = link;
        this.loading = false;
      } else {
        const fileName = link.substring(0, link.lastIndexOf(".") + 1) + "pdf";
        console.log(fileName);
        var loadingTask = pdf.createLoadingTask({
          url: fileName,
          httpHeaders: this.header
        });
        this.src = loadingTask;
        // console.log(loadingTask)
        loadingTask.promise
          .then(pdf => {
            this.pageCount = pdf.numPages;
            console.log("总页数" + pdf.numPages);
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            this.$message({
              message: "加载失败！错误代码：" + err.details,
              type: "error",
              duration: 5 * 1000
            });
          });
      }
    },
    isImg(type) {
      if (this.imgType.indexOf(type) !== -1) {
        return true;
      }
      return false;
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
        // console.log(this.currentPage)
      }
    },
    // pdf加载时
    loadPdfHandler(e) {
      console.log(e);
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    openFullScreen() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    }
  }
};
</script>
<style lang="scss" scoped>
.pdf {
  background-color: #fff;
  // height: 600px;
  overflow: hidden;
  min-height: 500px;
  // overflow-y: auto;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(57, 70, 100, 0.8);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #ededed;
  }
}
.pdf-box {
  width: 100%;
  overflow: hidden;
}
.img-box {
  text-align: center;
}
.img {
  // width: 100%;
  max-width: 900px;
}
.pdf-img {
  width: 100%;
}
</style>
